import type { ConnMethod } from '../../api/types'

export interface MethodOption {
  value: ConnMethod
  label: string
  blurb: string
}

/** The customer-facing connection-method radio cards (portal + public
 *  onboarding). Each radio is `${testIdPrefix}-${value}`. */
export function AwsMethodPicker({
  options,
  value,
  onChange,
  name,
  testIdPrefix,
  margin,
}: {
  options: MethodOption[]
  value: ConnMethod
  onChange: (method: ConnMethod) => void
  name: string
  testIdPrefix: string
  margin: string
}) {
  return (
    <div role="radiogroup" aria-label="Connection method" style={{ display: 'grid', gap: '0.5rem', margin }}>
      {options.map((m) => (
        <label
          key={m.value}
          style={{
            display: 'flex',
            gap: '0.6rem',
            alignItems: 'baseline',
            border: '1px solid var(--border)',
            borderRadius: 8,
            padding: '0.6rem 0.8rem',
            cursor: 'pointer',
            background: value === m.value ? 'var(--surface-raised)' : 'transparent',
          }}
        >
          <input
            type="radio"
            name={name}
            checked={value === m.value}
            onChange={() => onChange(m.value)}
            data-testid={`${testIdPrefix}-${m.value}`}
          />
          <span>
            <strong>{m.label}</strong>
            <span className="muted" style={{ display: 'block', fontSize: '0.85rem' }}>
              {m.blurb}
            </span>
          </span>
        </label>
      ))}
    </div>
  )
}
